import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import Utils from './plugins/vue-utils'
import Vuelidate from 'vuelidate'
import VueMoment from 'vue-moment'
import VueQrcodeReader from "vue-qrcode-reader"
import './plugins/vue-lodash'
import './plugins/auth'
import './plugins/vue-role'

Vue.use(VueMoment)
Vue.use(Vuelidate)
Vue.use(Utils)
Vue.use(VueQrcodeReader)

Vue.router = router

Vue.router.beforeEach((to, from, next) => {
  const lang = localStorage.getItem(process.env.VUE_APP_I18N_LOCALE_NAME)
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  const defaultTitle = document.title = process.env.VUE_APP_DEFAULT_TITLE || 'Guest Management'
  if (nearestWithTitle) {
    document.title = i18n.t(nearestWithTitle.meta.title).trim().replace(/^\w/, (c) => c.toUpperCase()) + ' - ' + defaultTitle
  } else {
    document.title = defaultTitle
  }
  if (!lang) {
    store.commit('SET_LANG', 'fr')
    i18n.locale = 'fr'
  } else {
    store.commit('SET_LANG', lang)
    i18n.locale = lang
  }
  next()
})

Vue.config.productionTip = process.env.VUE_APP_PRODUCTION_TIP || false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
